import { Modal } from './modal';
import { Carousel } from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm";

import 'regenerator-runtime/runtime';

export class Actions {

  constructor () {

    this._resourceToModal = this._resourceToModal.bind(this);
    this._hudognikVote = this._hudognikVote.bind(this);

    this.xhrurl = '/assets/components/nonfiction/webconnector.php';

    if (document.querySelector('meta[name="csrf-token"]')) {
      this.csrf = document.querySelector('meta[name="csrf-token"]').content;
    } else {
      this.csrf = '';
    }


    // document.querySelectorAll('[data-action="resourceToModal"]').forEach(el => {
    //   el.addEventListener('click', this._resourceToModal);
    // });

    this.offset = 0;
    document.addEventListener('click', (e) => {

      if (e.target.dataset.action === 'resourceToModal') {
        this._resourceToModal(e);
      }

      if (e.target.dataset.action === 'hudognikVote') {
        this._hudognikVote(e);
      }
      if (e.target.dataset.action === 'scrollTo') {
        this._scrollTo(e);
      }


    });


  }

  async _hudognikVote(e) {
    e.preventDefault();


    try {
      const params = {
        // url: xhrurl,
        action: e.target.dataset.action,
        vote: e.target.dataset.vote,
        bookid: e.target.dataset.bookid,
      };

      const datax = new URLSearchParams(params).toString();

      const response = await fetch(this.xhrurl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          "X-Requested-With": "XMLHttpRequest",
          'X-CSRF-TOKEN': this.csrf,
        },
        body: datax,
      });

      const obj = await response.json();

      if (obj.success) {
        
        e.target.parentNode.querySelectorAll('button').forEach(button => {
          button.classList.remove('active');
        });
        e.target.classList.add('active');

      }

      
    } catch (error) {

      console.log(error);

    }


    
  }

  _scrollTo(e) {
    e.preventDefault();
    if (!e.target.classList.contains('is-active') && !e.target.parentNode.classList.contains('is-active')) {
      document.querySelector(`#${e.target.dataset.id}`).scrollIntoView({ behavior: "smooth" });
    }
  }

  async _resourceToModal(e) {
    // console.log(e.target);

    e.preventDefault();
    try {
      const params = {
        // url: xhrurl,
        action: e.target.dataset.action,
        resourceToModal: e.target.dataset.id,

      };

      const datax = new URLSearchParams(params).toString();

      const response = await fetch(this.xhrurl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          "X-Requested-With": "XMLHttpRequest",
          'X-CSRF-TOKEN': this.csrf,
        },
        body: datax,
      });

      const obj = await response.json();

      if (obj.success) {
        const modal = new Modal();
        
        if (obj.object.introtext){ obj.object.modaldata = `<p><i>${obj.object.introtext}</i></p>${obj.object.modaldata}`}
        modal.data(obj.object.modaltitle, obj.object.modaldata, obj.object.buttons, obj.object.images);
        modal.active();

        if (obj.object.images) {
          new Carousel(document.querySelector('.f-carousel'), {
            Autoplay: {
              timeout: 3000,
              showProgress: false
            },
            transition: "slide",
            slidesPerPage: 1,
            Dots: false,
          });

          
        }

      }

      
    } catch (error) {

      console.log(error);

    }

  }

}

const actions = new Actions();